import { formatWeeks } from '@aytm/app/stats/page/question-views/ec/lib/formatWeeks'

// Port of getFrequencyAnswer / getFrequencyBatches (chart.coffee:363-412) and formatWeeks
// (lib.coffee). Delivery frequency renders as a stacked chart: one bar per product, one
// segment per subscription interval the study offered.

// Chronological order keeps the stacked segments lined up across products.
const sortedCategories = answer =>
  (answer?.subscribe?.frequencyDistribution || []).slice().sort((a, b) => a.weeks - b.weeks)

export const getFrequencyAnswer = ({ answer, answerVariants }) => {
  const categories = sortedCategories(answer)
  const hcAnswers = {}

  for (const av of answerVariants || []) {
    const ak = `a${av.position}`
    const bk = `b${av.position}`

    const productFreq = answer?.subscribe?.[ak]?.frequency || []
    const freqByWeeks = {}
    for (const f of productFreq) freqByWeeks[f.weeks] = f

    const bAnswer = {
      amount: productFreq.reduce((sum, f) => sum + (f.pct || 0), 0),
      total: answer?.total || 0
    }

    // Products that were never offered an interval still need a zero segment for it,
    // otherwise the stack misaligns against the products that were.
    categories.forEach((cat, idx) => {
      const f = freqByWeeks[cat.weeks] || { pct: 0, count: 0 }
      bAnswer[`a${idx + 1}`] = { amount: f.count || 0, percents: f.pct || 0 }
    })

    hcAnswers[bk] = bAnswer
  }

  return hcAnswers
}

export const getFrequencyBatches = ({ answer, answerVariants }) => {
  const categories = sortedCategories(answer)

  // Fresh variant objects per batch — coffee shared one array across every batch, but the
  // sibling getBatches deliberately avoids that so Highcharts cannot mutate across bars.
  return (answerVariants || []).map(av => ({
    position: av.position,
    text: av.text,
    fixed: false,
    answerVariants: categories.map((cat, idx) => ({
      position: idx + 1,
      text: `Every ${formatWeeks(cat.weeks, true)}`,
      fixed: false,
      positive: true,
      score: idx + 1
    }))
  }))
}
